
import { Link } from "react-router-dom";
import { Department } from "./departmentData";

interface DepartmentsByRegionProps {
  departmentsByRegion: Record<string, Department[]>;
}

const DepartmentsByRegion = ({ departmentsByRegion }: DepartmentsByRegionProps) => {
  return (
    <div className="mt-12 prose max-w-none">
      <h3 className="text-xl font-heading font-bold mb-4 text-fabre-gray">
        Nos services par département
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-6">
        <div>
          <h4 className="text-lg font-semibold text-fabre-green mb-3">Occitanie</h4>
          <ul className="space-y-2 list-disc list-inside text-gray-700">
            {departmentsByRegion["Occitanie"].map((dept) => (
              <li key={dept.code}>
                <Link 
                  to={`/sites?dept=${dept.code}`}
                  className="hover:text-fabre-green hover:underline"
                  title={`Services de recyclage et gestion des déchets dans le ${dept.name}`}
                >
                  {dept.name} ({dept.code})
                </Link>
              </li>
            ))}
          </ul>
        </div>
        
        <div>
          <h4 className="text-lg font-semibold text-fabre-green mb-3">Auvergne-Rhône-Alpes</h4>
          <ul className="space-y-2 list-disc list-inside text-gray-700">
            {departmentsByRegion["Auvergne-Rhône-Alpes"].map((dept) => (
              <li key={dept.code}>
                <Link 
                  to={`/sites?dept=${dept.code}`}
                  className="hover:text-fabre-green hover:underline"
                  title={`Services de recyclage et gestion des déchets dans le ${dept.name}`}
                >
                  {dept.name} ({dept.code})
                </Link>
              </li>
            ))}
          </ul>
        </div>
        
        <div>
          <h4 className="text-lg font-semibold text-fabre-green mb-3">Île-de-France</h4>
          <ul className="space-y-2 list-disc list-inside text-gray-700">
            {departmentsByRegion["Île-de-France"].map((dept) => (
              <li key={dept.code}>
                <Link 
                  to={`/sites?dept=${dept.code}`}
                  className="hover:text-fabre-green hover:underline"
                  title={`Services de recyclage et gestion des déchets dans le ${dept.name}`}
                >
                  {dept.name} ({dept.code})
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-8 text-gray-700">
        <p>
          Le Groupe Fabre Environnement propose ses services de collecte, recyclage et valorisation des déchets dans plusieurs régions de France. 
          Notre expertise s'étend à travers l'Occitanie, l'Auvergne-Rhône-Alpes et l'Île-de-France, où nous disposons 
          de centres spécialisés pour répondre à tous vos besoins en matière de gestion des déchets.
        </p>
        <p className="mt-4">
          Que vous soyez un professionnel, une collectivité ou un particulier, nous vous proposons des solutions 
          adaptées à vos besoins spécifiques dans chacun de nos départements d'intervention.
        </p>
      </div>
    </div>
  );
};

export default DepartmentsByRegion;
